import * as React from 'react';

import { LocationWithCoordinates } from 'lib/types';
import { LocationsContext } from '../components/LocationsProvider';

export default function useAvailableLocations(): ReadonlyArray<LocationWithCoordinates> {
    const { locations: allLocations } = React.useContext(LocationsContext);
    return React.useMemo(() => {
        return allLocations.filter((location) => location.bookingEnabled);
    }, [allLocations]);
}
